<template>
    <DefaultLayout>
        <ProdevBanner v-if="main.has_module_banner_prodev"></ProdevBanner>
        <RoadMapBar v-if="main.has_module_roadmap_bar"/>
        <div style="margin-top:63vh" v-if="main.has_module_banner_prodev || main.has_module_roadmap_bar"></div>
        <WelcomeMessage v-if="store.token" />         
        <InformationTop v-if="store.token && main.has_module_banner"/>
        <BannerTop v-if="main.has_social_network_advice"/>
        <MyRoutes v-if="store.token && main.has_module_my_routes" />
        <MyCourses v-if="store.token" />
        <LaterLessons v-if="store.token" />
        <FavLessons v-if="store.token" />
        <div class="spacer" v-if="!store.token" />
        <div class="spacer" v-if="!store.token" />
        <div class="spacer" v-if="!store.token" />
        <div class="spacer" v-if="!store.token" />
        <div class="spacer" v-if="!store.token" />
        <h1>Empieza algo nuevo</h1>
        <StartHere />
        <button v-if="main.has_module_agenda" class="fixed_btn"> <a href="https://avemariamalaga.netlify.app/acceso"  :style="{backgroundColor: main.SECONDARY_COLOR}" class="fixed_btn"  target="_blank">Notificaciones Familias</a></button>
    </DefaultLayout>
</template>

<script lang="ts" setup>
import InformationTop from '@/components/layouts/InformationTop.vue'
import main from '@/data/main.js'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import MyRoutes from '@/components/sections/MyRoutes.vue'
import MyCourses from '@/components/sections/MyCourses.vue'
import FavLessons from '@/components/sections/FavLessons.vue'
import LaterLessons from '@/components/sections/LaterLessons.vue'
import StartHere from '@/components/sections/StartHere.vue'
import WelcomeMessage from '@/components/sections/WelcomeMessage.vue'
import { useAuth } from '@/store/useAuth'
import ProdevBanner from '@/components/layouts/ProdevBanner.vue';
import BannerTop from '@/components/layouts/BannerTop.vue'
import RoadMapBar from '@/components/layouts/RoadMapBar.vue'
//import AgendaRight from '@/components/layouts/AgendaRight.vue'
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'

const store = useAuth()
</script>

<style scoped>


.fixed_btn {
    position: fixed;
    bottom: 30px;
    right: 10px;
    height: 38px;
    border-radius: 5px;
    color: white;
    border: none;
    width: 250px;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-weight: bold;
    font-size: 16px;
    padding: 8px;
}
@media (max-width: 600px) {
    .fixed_btn {
        position: fixed;
        bottom: 80px;
        right: 20px;
        height: 38px;
        border-radius: 5px;
        color: white;
        border: none;
        width: 250px;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        font-weight: bold;
        font-size: 16px;
        padding: 8px;

    }
}


</style>
